import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

import { largeScreen } from "src/shared/constants/screenSizes";

export const ContentWrapper = styled.div`
  background-color: white;
  box-shadow: -6px 0px 6px 0 rgba(0, 0, 0, 0.2);
  height: 100%;
  position: fixed;
  top: 0;
  transition: ${({ isLeftSide }) => (isLeftSide ? "left 0.5s" : "right 0.5s")};
  width: 480px;
  z-index: 1001;

  ${({ animate, isLeftSide }) =>
    `${isLeftSide ? "left" : "right"} : ${animate ? "0" : "-490px"}`};
`;

export const Overlay = styled.div`
  background: ${({ isDarkOverlay }) =>
    isDarkOverlay ? `rgba(39, 45, 57, 0.2)` : `rgba(255, 255, 255, 0.7)`};
  display: ${({ animate }) => (animate ? "block" : "none")};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${colorPalette.pureWhite};
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${largeScreen}px) {
    height: 100vh;
  }
`;

ContentWrapper.displayName = "ContentWrapper";
Overlay.displayName = "Overlay";
